export const LIST_PAGE_SIZE = 30;
